import { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';
import { Textarea } from '../../ui/textarea';

export function GeneralInformation() {
  const [formData, setFormData] = useState({
    companyName: '',
    industry: '',
    salesStage: '',
    headquarters: '',
    additionalLocations: '',
  });

  const industries = [
    'Technology',
    'Healthcare',
    'Finance',
    'Manufacturing',
    'Retail',
    'Education',
    'Real Estate',
    'Construction',
    'Other',
  ];

  const salesStages = [
    'Lead',
    'Qualified',
    'Proposal',
    'Negotiation',
    'Contract',
    'Closed Won',
    'Closed Lost',
  ];

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Company Details</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label htmlFor="companyName">
                Company Name <span className="text-destructive">*</span>
              </Label>
              <Input
                id="companyName"
                placeholder="Enter company name"
                value={formData.companyName}
                onChange={(e) => setFormData((prev) => ({ ...prev, companyName: e.target.value }))}
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="industry">
                Industry <span className="text-destructive">*</span>
              </Label>
              <Select
                onValueChange={(value) => setFormData((prev) => ({ ...prev, industry: value }))}
              >
                <SelectTrigger>
                  <SelectValue placeholder="Select industry" />
                </SelectTrigger>
                <SelectContent>
                  {industries.map((industry) => (
                    <SelectItem key={industry} value={industry.toLowerCase()}>
                      {industry}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label htmlFor="salesStage">
                Current Sales Stage <span className="text-destructive">*</span>
              </Label>
              <Select
                onValueChange={(value) => setFormData((prev) => ({ ...prev, salesStage: value }))}
              >
                <SelectTrigger>
                  <SelectValue placeholder="Select current stage" />
                </SelectTrigger>
                <SelectContent>
                  {salesStages.map((stage) => (
                    <SelectItem key={stage} value={stage.toLowerCase().replace(' ', '-')}>
                      {stage}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div className="space-y-2">
              <Label htmlFor="headquarters">
                Headquarters Location <span className="text-destructive">*</span>
              </Label>
              <Input
                id="headquarters"
                placeholder="City, State/Country"
                value={formData.headquarters}
                onChange={(e) => setFormData((prev) => ({ ...prev, headquarters: e.target.value }))}
              />
            </div>
          </div>

          <div className="space-y-2">
            <Label htmlFor="additionalLocations">Additional Locations</Label>
            <Textarea
              id="additionalLocations"
              placeholder="List other office locations (optional)"
              rows={3}
              value={formData.additionalLocations}
              onChange={(e) =>
                setFormData((prev) => ({ ...prev, additionalLocations: e.target.value }))
              }
            />
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Company Overview</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="space-y-2">
              <Label htmlFor="companySize">Company Size</Label>
              <Select>
                <SelectTrigger>
                  <SelectValue placeholder="Select size" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="startup">1-10 employees</SelectItem>
                  <SelectItem value="small">11-50 employees</SelectItem>
                  <SelectItem value="medium">51-200 employees</SelectItem>
                  <SelectItem value="large">201-1000 employees</SelectItem>
                  <SelectItem value="enterprise">1000+ employees</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div className="space-y-2">
              <Label htmlFor="revenue">Annual Revenue</Label>
              <Select>
                <SelectTrigger>
                  <SelectValue placeholder="Select range" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="under-1m">Under $1M</SelectItem>
                  <SelectItem value="1m-10m">$1M - $10M</SelectItem>
                  <SelectItem value="10m-50m">$10M - $50M</SelectItem>
                  <SelectItem value="50m-100m">$50M - $100M</SelectItem>
                  <SelectItem value="over-100m">Over $100M</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div className="space-y-2">
              <Label htmlFor="founded">Founded Year</Label>
              <Input id="founded" placeholder="e.g., 2020" type="number" />
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
